import { View, Image} from "@aws-amplify/ui-react";
import styled, { useTheme } from "styled-components";
import Logo from "../media/aere_logo_caption_black.png";
 
const LoginImage = styled(Image)`
    width:200px;
    margin-top:30px;
    margin-bottom:30px;
`

export const LoginGlobalHeader = () => {
    //const { tokens } = useTheme();

    return (
        <View textAlign="center">
        <LoginImage
            alt="Aere Logo"
            src={Logo}
        />
        </View>
    );
}